import moment from "moment";
import { LoadState } from "../../../constants/enums";
import { getUniqueId } from "../../../helpers";

export interface IAccountingInvoiceInformationState {
  list: IInvoiceInformation[];
  listLoading: LoadState;
  data: IInvoiceInformation;
  loading: LoadState;
  error: string | null;
}

export interface IInvoiceDetails {
  key: string;
  type: string | null;
  detail: string | null;
  description: string | null;
  amount: string | null;
  tax_1_percentage: string | null;
  tax_1_amount: string | null;
  tax_2_percentage: string | null;
  tax_2_amount: string | null;
  commission_percentage: string | null;
  commission_amount: string | null;
  house_percentage: string | null;
  house_amount: string | null;
  producer_1_percentage: string | null;
  producer_1_amount: string | null;
  producer_2_percentage: string | null;
  producer_2_amount: string | null;
  producer_3_percentage: string | null;
  producer_3_amount: string | null;
  total_amount: string | null;

}

export interface IInvoiceInformation {
  invoice_id: string | null;
  invoice_number: string | null;
  invoice_due_date: string | null;
  payment_terms: string | null;
  accounting_information_id: string | null;
  customer_or_code: string | null;
  policy_id: string | null;
  type_of_policy: string;
  policy_transaction_type: string | null;
  policy_status: string | null;
  transaction_date: string | null;
  effective_date: string | null;
  default_tax_region: string | null;
  agency_or_direct_bill: string | null;
  insurer_code: string | null;
  premium_financed: string | null;
  financed_by: string | null;
  invoice_details: IInvoiceDetails[];
  sub_total_dollar: string | null;
  net_payable_dollar: string | null;
  invoice_notes: string | null;
  invoice_footer_information: string | null;
  total_due_dollar: string | null;
  status: string;
}

export const initialAccountingInvoiceInformationState: IAccountingInvoiceInformationState =
  {
    list: [],
    listLoading: LoadState.NotLoaded,
    data: {
      invoice_id: null,
      invoice_number: null,
      invoice_due_date: moment().format("MM-DD-YYYY").toString(),
      payment_terms: null,
      accounting_information_id: null,
      customer_or_code: null,
      policy_id: null,
      type_of_policy: "",
      policy_transaction_type: null,
      policy_status: null,
      transaction_date: moment().format("MM-DD-YYYY").toString(),
      effective_date: null,
      default_tax_region: null,
      agency_or_direct_bill: null,
      insurer_code: null,
      premium_financed: null,
      financed_by: null,
      invoice_details: [
        {
          key: getUniqueId(),
          type: null,
          detail: null,
          description: null,
          amount: null,
          tax_1_percentage: null,
          tax_1_amount: null,
          tax_2_percentage: null,
          tax_2_amount: null,
          commission_percentage: null,
          commission_amount: null,
          house_percentage: null,
          house_amount: null,
          producer_1_percentage: null,
          producer_1_amount: null,
          producer_2_percentage: null,
          producer_2_amount: null,
          producer_3_percentage: null,
          producer_3_amount: null,
          total_amount: null,

        },
      ],
      sub_total_dollar: null,
      net_payable_dollar: null,
      invoice_notes: null,
      invoice_footer_information: null,
      total_due_dollar: null,
      status: "ACTIVE",
    },
    loading: LoadState.NotLoaded,
    error: null,
  };
